import React from 'react'

const Map = () => {
    return (
        <React.Fragment>
            <div>
                <div className="w-full h-80 lg:h-[500px] mt-10">
                    <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3742.3333342090955!2d85.84521397469501!3d20.286465312860503!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a1909fa550b44cd%3A0x35d98036504a40ad!2sBangkok%20Spa!5e0!3m2!1sen!2sin!4v1734676092848!5m2!1sen!2sin"
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen=""
                        loading="lazy"
                    />
                </div>
            </div>
        </React.Fragment>
    )
}

export default Map